import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// 各个国家的key
const localeKeys = ['en', 'es', 'zh-CN', 'zh-TW'];

// 各个国家语言包
const messages = {};
for (const key of localeKeys) {
    const langObj = require(`./locales/${key}`).default;
    const langElement = require(`./element/${key}`);
    messages[key] = {
        ...langObj,
        ...langElement ? langElement.default : {}
    };
}

let language = navigator.language;
// eslint-disable-next-line no-console
console.log('系统默认： ' + language);
let defaultLanguage = 'zh-CN';
if (language.startsWith('en')) { // 英语
    defaultLanguage = 'en';
} else if (language.startsWith('es')) { // 西班牙语
    defaultLanguage = 'es';
} else if (language.startsWith('zh-TW')) { // 简体中文或繁体中文
    defaultLanguage = 'zh-TW';
} else {
    defaultLanguage = 'zh-CN';
}

export default new VueI18n({
locale: localStorage.getItem('change-language') || defaultLanguage,
messages,
silentTranslationWarn: true // 忽略翻译警告

});
